<div class="section">

  <ng-container *ngIf="statusSuccess">
    <div i18n="@@payamentSuccess" *ngIf="statusSuccess == '1'" class="notification is-success has-text-centered">
      Pagamento effettuato con successo!
    </div>
    <div i18n="@@payamentFailed" *ngIf="statusSuccess == '0'" class="notification is-danger has-text-centered">
      Pagamento fallito!
    </div>
  </ng-container>

  <div class="example-loading-shade"
       *ngIf="isLoadingResults || isRateLimitReached">
    <nwb-spinner *ngIf="isLoadingResults" color="#4baed0"></nwb-spinner>
  </div>

  <div i18n="@@payamentNotAvailable" *ngIf="!data || data.length == 0" class="notification is-primary">
    <p class="has-text-centered">Non risultano pagamenti</p>
  </div>
  <div *ngFor="let pagamento of data">
    <riga-pagamenti class="box" [pagamento]="pagamento"></riga-pagamenti>
  </div>
</div>
